'use client';

import { Send } from 'lucide-react';
import Link from 'next/link';
import { useAnalytics } from '@/services/frontendAnalyticsService';

interface ArticleAIResearchCTAProps {
  postSlug: string;
  shortTitle?: string | null;
}

export function ArticleAIResearchCTA({
  postSlug,
  shortTitle,
}: ArticleAIResearchCTAProps) {
  const analytics = useAnalytics();
  const descriptionText = shortTitle
    ? `Agen Riset Cepat (Jivara) akan menelusuri ${shortTitle}, mengekstrak pasal, dan menyusun analisis hukum yang akurat.`
    : 'Agen Riset Cepat (Jivara) akan menelusuri database peraturan, mengekstrak pasal, dan menyusun analisis hukum yang akurat.';

  const handleClick = () => {
    analytics.blog.featuresCTAClicked({
      postSlug,
      ctaType: 'jivara',
      ctaLabel: 'Agen Riset Cepat (Jivara)',
    });
  };

  return (
    <div className="not-prose my-12 border-2 border-neutral-200 rounded-xl p-6 md:p-8 bg-white">
      <Link href="/id/home" className="block group" onClick={handleClick}>
        <div className="w-full flex flex-col items-center">
          <div className="w-full max-w-2xl flex flex-col items-center">
            <div className="mb-6 text-center space-y-3">
              <h3 className="text-2xl md:text-3xl font-semibold text-neutral-900 tracking-tight">
                Apa yang ingin Anda teliti?
              </h3>
              <p className="text-neutral-500 text-sm max-w-lg mx-auto leading-relaxed">
                {descriptionText}
              </p>
            </div>

            <div className="w-full relative bg-white border border-neutral-300 rounded-xl shadow-sm group-hover:border-neutral-400 group-hover:shadow-md transition-all flex flex-col">
              <div className="p-4">
                <div className="flex items-start gap-3 min-h-[60px]">
                  <p className="text-neutral-400 text-[15px] leading-relaxed flex-1">
                    Masukkan konteks hukum atau pertanyaan spesifik...
                  </p>
                </div>
              </div>

              <div className="flex items-center justify-between px-4 py-3 border-t border-neutral-100">
                <div className="flex items-center gap-1.5">
                  <span className="text-[10px] font-semibold text-neutral-400 uppercase tracking-wider mr-1">
                    Sumber:
                  </span>
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium border bg-neutral-900 border-neutral-900 text-white">
                    Database Internal
                  </span>
                </div>

                <div className="bg-emerald-600 text-white p-2 rounded-lg group-hover:bg-emerald-700 transition-colors shrink-0">
                  <Send className="w-4 h-4" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
